import type { RouteConfig } from "@/types/routestypes";
import React from "react";
import { Navigate } from "react-router-dom";

const SignUp = React.lazy(() => import("@/pages/Auth/SignUp/SignUp"));
const Login = React.lazy(() => import("@/pages/Auth/Login/Login"));
const ForgotPassword = React.lazy(() => import("@/pages/Auth/ForgotPassword/ForgotPassword"));
const ForgotPasswordOtp = React.lazy(() => import("@/pages/Auth/OtpVerification/ForgotPasswordOtp/ForgotPasswordOtp"));
const OtpVerification = React.lazy(() => import("@/pages/Auth/OtpVerification/OtpVerification"));

const AuthRoutes: RouteConfig = {
    path: "/auth",
    children: {
        DEFAULT: {
            path: "",
            element: <Navigate to="login" replace />,
        },
        LOGIN: {
            path: "login",
            element: <Login />
        },
        SIGN_UP: {
            path: "register",
            element: <SignUp />
        },
        FORGET_PASSWORD: {
            path: "forget-password",
            element: <ForgotPassword />
        },
        OTP_VERIFICATION: {
            path: "otp-verification",
            element: <OtpVerification />,
        },
        FORGOT_PASSWORD_OTP: {
            path: "reset-password",
            element: <ForgotPasswordOtp />,
        },
    }
}

export default AuthRoutes;